var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H7C6.44771 9 6 9.44772 6 10C6 10.5523 6.44771 11 7 11H13Z",
    fill: "#82822c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.a69878e7cae70597f00df900808a0bca.svg";
export { ForwardRef as ReactComponent };